import { MessageCircle, ArrowUpRight } from "lucide-react";
import { ARVI, waLink, DEFAULT_WA_MESSAGE } from "../../lib/arvi";

export default function FinalCTA() {
  return (
    <section
      id="contact"
      data-testid="final-cta-section"
      className="relative bg-maroon-deep text-ivory py-28 md:py-40 overflow-hidden grain"
    >
      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="max-w-4xl reveal">
          <p className="text-overline text-gold mb-8">Start Your Commission</p>
          <h2 className="font-display text-[clamp(2.5rem,7vw,6.5rem)] leading-[0.98] tracking-tight">
            Let's paint your
            <br />
            <span className="italic text-[hsl(var(--gold-soft))]">heirloom.</span>
          </h2>
          <p className="mt-8 max-w-xl text-ivory/75 text-[15px] md:text-base leading-relaxed">
            Message us on WhatsApp with your idea, occasion or a
            reference you love. We'll reply with design directions
            and pricing — directly from the artist's studio.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-whatsapp-cta"
              className="btn-cta-base btn-wa"
            >
              <MessageCircle className="h-4 w-4" />
              Chat on WhatsApp
            </a>
            <a
              href={ARVI.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-instagram-cta"
              className="btn-cta-base btn-ghost-dark"
            >
              Follow on Instagram
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <dl className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl">
            <div>
              <dt className="text-overline text-gold">WhatsApp</dt>
              <dd className="mt-3 font-display text-xl">{ARVI.whatsappDisplay}</dd>
            </div>
            <div>
              <dt className="text-overline text-gold">Instagram</dt>
              <dd className="mt-3 font-display text-xl">{ARVI.instagramHandle}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
